<style scoped>
.point-success {
  background-color: rgba(0, 125, 0, 0.2);
  color: #007d0080 !important;
}
.point-warning {
  background-color: rgba(255, 152, 0, 0.2);
  color: #ff980080 !important;
}
.point-danger {
  background-color: rgba(255, 0, 0, 0.1);
  color: #ff000080 !important;
}

.point-success-main {
  background-color: rgba(0, 125, 0, 0.5);
  color: #fff !important;
}
.point-warning-main {
  background-color: rgba(255, 152, 0, 0.5);
  color: #fff !important;
}
.point-danger-main {
  background-color: rgba(255, 0, 0, 0.5);
  color: #fff !important;
}

.nav-sidebar .nav-point {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  height: 25px;
  color: #99a6ad;
}

.nav-sidebar .nav-point:last-child {
  border-right: none;
}
</style>
<template>
  <div class="ht-100p">
    <div
      class="nav nav-sidebar text-center ht-100p"
      @click.stop="$emit('on-show-point')"
    >
      <main
        style="display: grid; grid-template-columns: repeat(1, 1fr); max-width: 100; width: 100%;"
        class="ht-100p"
      >
        <!-- <div class="nav-point" :class="{
          'point-success': task.learnEventPoint >= tmzPointEvent,
          'point-warning': task.learnEventPoint < tmzPointEvent && task.learnEventPoint>0 ,
        }" 
        >{{task.learnEventPoint}} </div>
        <div class="nav-point" :class="{
          'point-success': task.learnCoursePoint >= tmzPointCourse,
          'point-warning': task.learnCoursePoint < tmzPointCourse && task.learnCoursePoint>0 ,
        }"
        >{{task.learnCoursePoint}}</div>
        <div class="nav-point" :class="{
          'point-success': task.learnEthicPoint >= tmzPointReport,
          'point-warning': task.learnEthicPoint < tmzPointReport && task.learnEthicPoint>0 ,
        }"
        >{{task.learnEthicPoint}}</div>
        <div class="nav-point" :class="{
          'point-success': task.learnPaymentPoint >= tmzPointPayment,
          'point-warning': task.learnPaymentPoint < tmzPointPayment && task.learnPaymentPoint>0 ,
        }"
        >{{task.learnPaymentPoint}}</div>
        <div v-if="tmzPointExam>0" class="nav-point" :class="{
          'point-success': task.learnExamPoint >= tmzPointExam,
          'point-warning': task.learnExamPoint < tmzPointExam && task.learnExamPoint>0 ,
        }"
        >{{task.learnExamPoint}}</div> -->
        <div
          class="nav-point tx-bold ht-100p-f"
          :class="{
            'point-success-main': sumPoint >= tmzPointSuccess,
            'point-warning-main':
              sumPoint > tmzPointWarning && sumPoint < tmzPointSuccess,
            'point-danger-main': sumPoint <= tmzPointWarning && sumPoint > 0
          }"
        >
          {{ sumPoint }}
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import { getConfigValueByKey } from "@/libs/util";

export default {
  name: "memberpoint",
  props: {
    task: {
      type: Object,
      default: () => {}
    },
    sumPoint: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      modalPoint: false,
      tmzPointSuccess: 0,
      tmzPointWarning: 0,

      tmzPointReport: 0,
      tmzPointPayment: 0,
      tmzPointCourse: 0,
      tmzPointExam: 0,
      tmzPointEvent: 0
    };
  },
  mounted() {
    this.tmzPointSuccess = parseInt(
      getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "tmzPointSuccess"
      ),
      10
    );
    this.tmzPointWarning = parseInt(
      getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "tmzPointWarning"
      ),
      10
    );

    this.tmzPointReport = parseInt(
      getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "tmzPointReport"
      ),
      10
    );
    this.tmzPointPayment = parseInt(
      getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "tmzPointPayment"
      ),
      10
    );
    this.tmzPointCourse = parseInt(
      getConfigValueByKey(
        this.$store.state.app.groupSettings,
        "tmzPointCourse"
      ),
      10
    );
    this.tmzPointExam = parseInt(
      getConfigValueByKey(this.$store.state.app.groupSettings, "tmzPointExam"),
      10
    );
    this.tmzPointEvent = parseInt(
      getConfigValueByKey(this.$store.state.app.groupSettings, "tmzPointEvent"),
      10
    );
  },
  methods: {}
};
</script>
